import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, renderSlot as _renderSlot, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a239328"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  style: {"padding":"8px 4px","margin-top":"24px"},
  class: "ion-text-center"
}

import { IonText, IonList, IonItem, IonItemSliding, IonItemOptions } from '@ionic/vue';
import DocumentSmall from '@components/documents/DocumentSmall.vue'

import { TDocument } from '@/const/types/documents';

interface Props {
    documents: TDocument[];
    showDocumentCreator?: boolean;
    route: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BasicEntryDocumentList',
  props: {
    documents: null,
    showDocumentCreator: { type: Boolean },
    route: null
  },
  setup(__props: any) {

const props = __props as {
    documents: TDocument[];
    showDocumentCreator?: boolean;
    route: string;
};




return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(IonText), null, {
        default: _withCtx(() => [
          _createTextVNode(" No documents were found. ")
        ]),
        _: 1
      })
    ], 512), [
      [_vShow, _ctx.$props.documents.length < 1]
    ]),
    _createVNode(_unref(IonList), null, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.documents, (document) => {
          return (_openBlock(), _createBlock(_unref(IonItemSliding), {
            key: document.id
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonItem), null, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, {
                    to: { name: props.route, params: { id: document.id } },
                    class: "item__link"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(DocumentSmall, {
                        document: document,
                        "show-document-creator": props.showDocumentCreator
                      }, null, 8, ["document", "show-document-creator"])
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                _: 2
              }, 1024),
              _createVNode(_unref(IonItemOptions), { side: "end" }, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "default", { document: document })
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 3
    })
  ], 64))
}
}

})